import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbDropbox: BowlBlock = withIntegration(options.slug.llmKbDropbox, [
  {
    name: 'remoteUrl',
    type: 'withText',
    required: true,
  },
  {
    name: 'token',
    type: 'withText',
    required: true,
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
